import { reactive } from '@vue/composition-api'

const state = reactive({
  onboardingTech: '' as string,
  manualSelect: false,
})

export default state
